import { transformListToObject } from '@zc-react-admin/utils';

import { transformRecordToOption } from '@/utils/common';

export const yesOrNoRecord: Record<CommonType.YesOrNo, App.I18n.I18nKey> = {
  N: 'common.yesOrNo.no',
  Y: 'common.yesOrNo.yes'
};

export const yesOrNoOptions = transformRecordToOption(yesOrNoRecord);

export const DARK_CLASS = 'dark';

export const ATG_MAP: Record<Api.Common.EnableStatus, string> = {
  1: 'success',
  2: 'warning'
};

export const YesOrNo_Map: Record<CommonType.YesOrNo, string> = {
  N: 'default',
  Y: 'error'
};

export const LAYOUT_MODE_VERTICAL: UnionKey.ThemeLayoutMode = 'vertical';
export const LAYOUT_MODE_HORIZONTAL: UnionKey.ThemeLayoutMode = 'horizontal';
export const LAYOUT_MODE_VERTICAL_MIX: UnionKey.ThemeLayoutMode = 'vertical-mix';
export const LAYOUT_MODE_HORIZONTAL_MIX: UnionKey.ThemeLayoutMode = 'horizontal-mix';

export const COMMON_STATUS_LIST: CommonType.Option<boolean>[] = [
  { label: '显示', value: true },
  { label: '隐藏', value: false }
];
export const COMMON_SWITCH_LIST: CommonType.Option<boolean>[] = [
  { label: '开启', value: true },
  { label: '关闭', value: false }
];
export const COMMON_DEFAULT: CommonType.Option<any>[] = [{ label: '全部', value: '' }];

export const LANG_LIST: CommonType.Option<string>[] = [
  { label: '中文', value: 'zh_CN' },
  { label: '繁体', value: 'zh_TW' },
  { label: '英文', value: 'en_US' }
];
export const LANG_OPTIONS = transformListToObject(LANG_LIST);

export const PUBLISH_STATUS_LIST: CommonType.Option<boolean>[] = [
  { label: '是', value: true },
  { label: '否', value: false }
];
